import useScrollReveal from '@/hooks/useScrollReveal';

const steps = [
  {
    number: '01',
    title: 'Assessment',
    desc: 'We begin by understanding your background, goals, barriers, and strengths — building a complete picture of where you are and where you want to go.',
    icon: 'ri-focus-3-line',
  },
  {
    number: '02',
    title: 'Program Design',
    desc: 'A customized training path is mapped specifically to your employment goals, learning style, and timeline — not a generic one-size-fits-all plan.',
    icon: 'ri-file-list-3-line',
  },
  {
    number: '03',
    title: 'Skills Training',
    desc: 'Hands-on vocational learning, job readiness coaching, life skills development, and employer-aligned curriculum delivered in real training environments.',
    icon: 'ri-tools-line',
  },
  {
    number: '04',
    title: 'Placement & Support',
    desc: 'Direct employer connections, job placement coordination, and post-hire follow-up to ensure your transition into employment is successful and lasting.',
    icon: 'ri-user-star-line',
  },
];

const ProcessSteps = () => {
  const headerRef = useScrollReveal();
  const stepsRef = useScrollReveal();

  return (
    <section className="bg-cream py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div ref={headerRef} className="reveal text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-gold" />
            <span className="font-inter text-gold text-xs font-semibold tracking-[0.25em] uppercase">How It Works</span>
            <div className="w-8 h-[2px] bg-gold" />
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-charcoal">
            A Structured Path to Employment
          </h2>
          <p className="font-inter text-base text-charcoal/60 mt-4 max-w-lg mx-auto">
            Every participant follows a proven four-stage process — from assessment to job placement — built to maximize outcomes.
          </p>
        </div>

        {/* Steps */}
        <div ref={stepsRef} className="reveal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={step.number} className={`relative delay-${i * 100}`}>
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(100%_-_16px)] w-[calc(100%_-_32px)] h-[2px] bg-gradient-to-r from-gold/50 to-gold/10 z-10" />
              )}
              <div className="bg-white rounded-lg p-7 border border-cream-100 h-full hover:border-gold/30 transition-colors duration-200">
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-charcoal rounded-lg shrink-0">
                    <i className={`${step.icon} text-gold text-xl`} />
                  </div>
                  <span className="font-playfair text-4xl font-bold text-charcoal/10 leading-none select-none">
                    {step.number}
                  </span>
                </div>
                <h3 className="font-playfair text-xl font-bold text-charcoal mb-3">
                  {step.title}
                </h3>
                <p className="font-inter text-sm text-charcoal/60 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
